import { Injectable, Signal, WritableSignal, inject, signal } from "@angular/core";
import { finalize } from "rxjs";
import { environment } from "src/environments/environment";
import { IProjectStageDto } from "src/models/new-dwelling/new-dwelling.model";
import { createAndShowExcel } from "src/util/tools/excel.utils";
import { HttpDataService, IResponseWrapper } from "../httpdata.service";

@Injectable()
export class NewDwellingListExportService {
    private readonly http = inject(HttpDataService);
    private readonly listNewDwellingExcelUrl = `${environment.apiUrl}/Report/ListNewDwellingExcel`;

    private readonly _isExporting: WritableSignal<boolean> = signal(false);
    readonly isExporting: Signal<boolean> = this._isExporting.asReadonly();

    exportProjectsToExcel(projects: IProjectStageDto[], workbookName: string = null): void {
        if (!projects?.length || this._isExporting()) return;

        this._isExporting.set(true);
        this.http
            .post<IResponseWrapper<string[]>>(this.listNewDwellingExcelUrl, { projects, workbookName })
            .pipe(finalize(() => this._isExporting.set(false)))
            // data: [base64 content, file name, mime type]
            .subscribe({
                next: (res) => res?.data?.[0] && createAndShowExcel(res.data),
                error: (err) => console.error("Error exporting to Excel:", err),
            });
    }
}
